module.exports = __webpack_public_path__ + "img/submit.22ab1a79.svg";